import { getOneTimeToken } from 'api/patients';
import QueryKeys from 'api/queries/queryKeys';
import { UserQueryParams } from 'interfaces/queryParams';
import { IQueryRequest } from 'interfaces/request';
import { useQuery } from 'react-query';

function useOneTimeToken({ params, options }: IQueryRequest<UserQueryParams>) {
  const { userId } = params;
  return useQuery({
    ...options,
    queryFn: async () => {
      const { data } = await getOneTimeToken(userId);
      return data.data;
    },
    queryKey: [QueryKeys.getOneTimeToken, userId],
    refetchOnMount: false,
  });
}

export default useOneTimeToken;
